<div class="space-y-5 [@media(max-height:712px)]:space-y-4 [@media(max-height:607px)]:space-y-3">
    @if (!mixedMode()) {
    <!-- Header Section -->
    <header class="flex flex-col justify-between gap-4 [@media(max-height:607px)]:gap-2"
        [ngClass]="{'lg:flex-row lg:items-center': !_commonService.isPanelOpen()}">
        <h1
            class="text-xl lg:text-2xl [@media(max-height:712px)]:text-xl font-bold text-slate-800 dark:text-white whitespace-nowrap">
            Training and Demo
            Analytics</h1>

        <div class="flex flex-wrap items-center gap-3 w-full"
            [ngClass]="{'lg:w-auto justify-between': _commonService.isPanelOpen(), 'justify-end': !_commonService.isPanelOpen()}">
            <!-- Date Filter -->
            <app-date-picker [size]="'md'" (dateRangeChange)="onDateRangeChange($event)" [showComparison]="true"
                [showGroupBy]="true">
            </app-date-picker>

            <app-dropdown [options]="businessTypeOptions" [selectedValue]="business_type()" placeholder="Business Type"
                variant="themeBase" size="md" className="min-w-[150px]" [iconName]="'chartLine'"
                textClass="text-sm text-gray-900 dark:text-white" [triggerIconSize]="16" iconClass="text-purple-500"
                (selectionChange)="onBusinessTypeChange($event)"></app-dropdown>

            @if (isDenefits()) {
            <button (click)="openAiAssistant()"
                class="gradient-border text-[#141437] dark:text-white text-sm lg:text-xs font-medium px-5 lg:px-3 py-2.5 lg:py-3 rounded-lg transition-all duration-200 shadow-[0px_6px_12px_-6px_#AD46FF] hover:shadow-[0px_7px_12px_-5px_#AD46FF] flex items-center gap-2 disabled:opacity-50 cursor-pointer disabled:cursor-not-allowed">
                <app-icon name="sparkles" [size]="16" />
                Ask Prism AI
            </button>
            }

            <button (click)="openCustomizeLayout()"
                class="flex items-center gap-1.5 px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-medium hover:border-[#AD46FF]/60 hover:text-[#AD46FF] transition-all duration-200 shadow-sm whitespace-nowrap">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect width="7" height="7" x="3" y="3" rx="1" />
                    <rect width="7" height="7" x="14" y="3" rx="1" />
                    <rect width="7" height="7" x="14" y="14" rx="1" />
                    <rect width="7" height="7" x="3" y="14" rx="1" />
                </svg>
                Customize layout
            </button>
        </div>
    </header>
    }


    <!-- Customizable 12-col grid.
         Cards are rendered in the persisted order with the persisted col-span;
         visibility, width, and order are all controlled from the Customize
         Layout popup and applied via `applyLayoutEditor()`. -->
    <div class="grid grid-cols-12 gap-4 [@media(max-height:607px)]:gap-3 grid-flow-row-dense">
        @for (sec of embeddedVisibleSections(); track trackSection($index, sec)) {
        <div [ngClass]="getSectionColClass(sec)" class="group relative h-full">
            @if (isSectionLoading(sec.id)) {
            <app-individual-toaster fontSize="16px" />
            }

            @if (!mixedMode()) {
            <button type="button" (click)="addToCustomDashboard(sec); $event.stopPropagation()"
                [disabled]="isAddingToCustomDashboard(sec.id)"
                class="group/pin absolute cursor-pointer top-2 right-2 z-20 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
                [ngClass]="isAddedToCustomDashboard(sec.id)
                    ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
                    : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
                [attr.aria-label]="isAddedToCustomDashboard(sec.id) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
                [title]="isAddedToCustomDashboard(sec.id) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
                @if (isAddingToCustomDashboard(sec.id)) {
                <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                <span>{{ isAddedToCustomDashboard(sec.id) ? 'Removing' : 'Adding' }}&hellip;</span>
                } @else if (isAddedToCustomDashboard(sec.id)) {
                <!-- Pinned state: pill is permanently visible at top-right
                         (state indicator). At rest it stays compact — just the
                         green check icon — so the card title beneath stays fully
                         readable. Hovering the pill morphs it open (max-width
                         animates) and flips the affordance from "Added" (check)
                         to "Remove from Custom Dashboard" (minus) so the toggle
                         action remains discoverable. The negative margin on the
                         label cancels the flex gap while collapsed so the
                         at-rest pill looks like a tight icon-only circle. -->
                <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5" />
                </svg>
                <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11"
                    height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
                    from Custom Dashboard</span>
                } @else {
                <!-- Not-pinned state: pill is hidden at card-rest (opacity-0).
                         On card hover it fades in as a compact "+" icon only.
                         Hovering the icon itself then morphs the pill open
                         (max-width animates) to reveal the full "Pin to Custom
                         Dashboard" label. The negative margin on the label
                         collapses the flex gap when the label is closed so the
                         at-rest icon stays visually centred in a small circle. -->
                <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                </svg>
                <span
                    class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
                    to Custom Dashboard</span>
                }
            </button>
            }

            @switch (sec.id) {

            <!-- ▸ Stats Cards Overview -->
            <!--  All KPI tiles live inside one outer `card-bg` wrapper so the
                      hover-revealed "Pin to Custom Dashboard" button at the top-right
                      visually attaches to the whole stats group (instead of looking
                      like it only targets the last tile). The inner grid's column
                      count scales with the outer section's `colSpan` so tiles never
                      get squished when the card is shrunk via Customize Layout. -->
            @case (SectionId.STATS_OVERVIEW) {
            <div class="card-bg p-4 [@media(max-height:712px)]:p-3 rounded-2xl h-full">
                <div class="grid gap-4 [@media(max-height:607px)]:gap-3" [ngClass]="getStatsGridColsClass(sec)">
                    @for (card of statsCards(); track $index) {
                    <div
                        class="card-bg p-4 [@media(max-height:712px)]:p-3 rounded-2xl flex flex-col gap-3 [@media(max-height:712px)]:gap-2 transition-all hover:shadow-md group">
                        <div class="flex items-center gap-4 [@media(max-height:712px)]:gap-3">
                            <div
                                [class]="'w-12 h-12 [@media(max-height:712px)]:w-10 [@media(max-height:712px)]:h-10 rounded-2xl flex shrink-0 items-center justify-center text-white ' + card.iconBg + ' ' + card.shadow">
                                <app-icon [name]="card.icon" [size]="20"
                                    class="[@media(max-height:712px)]:scale-90"></app-icon>
                            </div>
                            <div class="flex flex-col">
                                <span
                                    class="text-xs font-semibold text-slate-400 dark:text-slate-500 uppercase tracking-wider [@media(max-height:712px)]:text-[10px]">{{
                                    card.label }}</span>
                                <span
                                    class="text-2xl font-bold text-slate-800 dark:text-white leading-none mt-1 [@media(max-height:712px)]:text-xl">{{
                                    card.value
                                    }}</span>
                            </div>
                        </div>
                        <div
                            class="text-xs font-medium text-slate-400 dark:text-slate-500 ml-16 [@media(max-height:712px)]:ml-13 [@media(max-height:712px)]:text-[10px]">
                            {{ card.subLabel }}
                        </div>
                    </div>
                    }
                </div>
            </div>
            }

            <!-- Key Insights -->
            <!-- <div
        class="card-bg p-6 [@media(max-height:712px)]:p-4 rounded-[1.5rem] flex flex-col gap-4">
        <div class="flex items-center gap-3">
            <app-icon name="circleAlert" [size]="24" class="text-amber-500"></app-icon>
            <h2 class="text-lg font-bold text-slate-800 dark:text-white font-outfit">Key Insights</h2>
        </div>
        <p class="text-sm text-slate-500 dark:text-slate-200 mt-[-8px]">Key takeaways to guide protect & growth
            decisions.</p>

        <ul class="space-y-4">
            @if (keyInsights().length > 0) {
            @for (insight of keyInsights(); track $index) {
            <li class="flex items-start gap-3 group">
                <div
                    class="mt-1.5 w-1.5 h-1.5 rounded-full bg-slate-300 dark:bg-slate-600 shrink-0 group-hover:bg-purple-500 transition-colors">
                </div>
                <span class="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">{{ insight }}</span>
            </li>
            }
            } @else {
            <div class="flex flex-col items-center justify-center py-8 text-gray-500">
                <app-icon name="inbox" [size]="48" class="text-gray-300 mb-2"></app-icon>
                <p class="text-sm font-medium">No insights available for the selected period.</p>
            </div>
            }
        </ul>
    </div> -->

            <!-- ▸ Monthly Training Performance Overview (Full Width) -->
            @case (SectionId.PERFORMANCE_OVERVIEW) {
            <div
                class="card-bg p-6 [@media(max-height:712px)]:p-4 rounded-2xl flex flex-col h-full min-h-[380px] [@media(max-height:712px)]:min-h-[320px] [@media(max-height:607px)]:min-h-[280px]">
                <div class="mb-4">
                    <h2 class="text-base font-bold text-slate-800 dark:text-white font-outfit">Monthly Training
                        Performance
                        Overview</h2>
                    <p class="text-sm text-slate-500 dark:text-slate-400 mt-0.5">Session Volume vs Completion & No-Show
                        Rates
                    </p>
                </div>

                <div class="flex-1 min-h-0">
                    @if (performanceData.length > 0) {
                    <app-bar-line [data1]="performanceData" [lines]="performanceLines" [legendData]="performanceLegend"
                        [colors]="performanceColors" [tooltipData]="performanceTooltip" [valueKey]="'total'"
                        [valueType]="''" [rightAxisType]="'percent'" [leftAxisLabel]="''" [rightAxisLabel]="''"
                        [margin]="{ top: 20, right: 50, bottom: 40, left: 60 }"
                        [labelKey]="performanceData[0]['unit_date'] ? 'unit_date' : (performanceData[0]['start'] ? 'start' : 'month_short')"
                        [showBackground]="false" [barTextposition]="'none'" [formatDateXAxis]="true"
                        [unit]="unit()"></app-bar-line>
                    } @else {
                    <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
                        <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
                        <p class="text-lg font-medium">No data available</p>
                        <p class="text-sm mt-1">Data will appear here when available</p>
                    </div>
                    }
                </div>
            </div>
            }

            <!-- ▸ Performance by Source Channel (Full Width) -->
            @case (SectionId.SOURCE_CHANNEL_PERFORMANCE) {
            <div
                class="card-bg p-6 [@media(max-height:712px)]:p-4 rounded-2xl flex flex-col h-full min-h-[380px] [@media(max-height:712px)]:min-h-[320px] [@media(max-height:607px)]:min-h-[280px]">
                <div class="mb-4">
                    <h2 class="text-base font-bold text-slate-800 dark:text-white font-outfit">Performance by Source
                        Channel
                    </h2>
                    <p class="text-sm text-slate-500 dark:text-slate-400 mt-0.5">Completion vs No-Show vs Cancellation
                        Rate
                        by
                        Source</p>
                </div>

                <div class="flex-1 min-h-0">
                    @if (sourceCompletionData.length > 0) {
                    <app-multiple-bar [data1]="sourceCompletionData" [data2]="sourceNoShowData"
                        [data3]="sourceCancellationData" [legendData]="sourceLegend" [colors]="sourceColors"
                        [tooltipData]="sourceTooltip" [valueKey]="'total'" [valueType]="'%'" [labelKey]="'label'"
                        [showDynamicxAxisLabel]="true" [showBarValues]="false" [addGradient]="false"
                        [barClusterPixel]="20" [showCard]="false" [showStripes]="true"
                        [legendPosition]="'center'"></app-multiple-bar>
                    } @else {
                    <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
                        <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
                        <p class="text-lg font-medium">No data available</p>
                        <p class="text-sm mt-1">Data will appear here when available</p>
                    </div>
                    }
                </div>
            </div>
            }

            <!-- ▸ Completion Rate by Training Type (Full Width) -->
            @case (SectionId.COMPLETION_BY_TYPE) {
            <div class="card-bg p-6 [@media(max-height:712px)]:p-4 rounded-2xl flex flex-col h-full">
                <div class="mb-4">
                    <h2 class="text-lg font-bold text-slate-800 dark:text-white">Completion Rate by Training Type
                    </h2>
                    <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">Identifying High & Low Performing
                        Curriculum
                        Segments</p>
                </div>

                <div
                    class="flex-1 overflow-x-auto min-h-[300px] [@media(max-height:712px)]:min-h-[250px] [@media(max-height:607px)]:min-h-[200px]">
                    @if (trainingTypeData.length > 0) {
                    <app-multi-horizontal-bar-chart [data]="trainingTypeData" [showXAxisGrid]="true"
                        [showYAxisGrid]="false" [leftMargin]="180" [barSpacing]="1" [categoryPadding]="2"
                        [barHeight]="isMidCompactView() ? 14 : 18" [showBarsValue]="false" [showLegend]="true"
                        [showStripes]="true" [valueType]="'%'"></app-multi-horizontal-bar-chart>
                    } @else {
                    <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
                        <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
                        <p class="text-lg font-medium">No data available</p>
                        <p class="text-sm mt-1">Data will appear here when available</p>
                    </div>
                    }
                </div>
            </div>
            }

            <!-- ▸ Cancellation Rate by Booking Lead Time -->
            @case (SectionId.CANCELLATION_LEAD_TIME) {
            <div
                class="card-bg p-8 [@media(max-height:712px)]:p-5 rounded-2xl flex flex-col h-full min-h-[500px] [@media(max-height:712px)]:min-h-[400px] [@media(max-height:607px)]:min-h-[350px]">
                <div class="mb-8">
                    <h2 class="text-lg font-bold text-slate-800 dark:text-white">Cancellation Rate by Booking Lead
                        Time
                    </h2>
                    <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">7+ day bookings cancel at 2.6x the
                        rate
                        of
                        same-day bookings.</p>
                </div>

                <div class="flex-1 min-h-0">
                    @if (leadTimeData.length > 0) {
                    <app-lollipop-chart [data]="leadTimeData" [valueFormat]="'percentage'" [showLegend]="false"
                        [minHeight]="isMidCompactView() ? 250 : 350"></app-lollipop-chart>
                    } @else {
                    <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
                        <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
                        <p class="text-lg font-medium">No data available</p>
                        <p class="text-sm mt-1">Data will appear here when available</p>
                    </div>
                    }
                </div>
            </div>
            }

            <!-- ▸ Session Status Distribution -->
            @case (SectionId.STATUS_DISTRIBUTION) {
            <div
                class="card-bg p-6 [@media(max-height:712px)]:p-4 rounded-2xl flex flex-col h-full min-h-[500px] [@media(max-height:712px)]:min-h-[400px] [@media(max-height:607px)]:min-h-[350px]">
                <div class="mb-4">
                    <h2 class="text-base font-bold text-slate-800 dark:text-white font-outfit">Session Status
                        Distribution
                    </h2>
                    <p class="text-sm text-slate-500 dark:text-slate-400 mt-0.5">Outcome Share of Total Filtered
                        Sessions
                    </p>
                </div>

                <div class="flex-1 flex items-center justify-center relative min-h-0">
                    @if (distributionData().length > 0) {
                    <app-donut-chart [data]="distributionData()" [variant]="'pie'"
                        [height]="isMidCompactView() ? 250 : 300" [showLegend]="true" [showLegendValue]="false"
                        labelFormat="value-percentage" centerTitle="Total Sessions" [centerValue]="totalSessions()">
                    </app-donut-chart>
                    } @else {
                    <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
                        <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
                        <p class="text-lg font-medium">No data available</p>
                        <p class="text-sm mt-1">Data will appear here when available</p>
                    </div>
                    }
                </div>
            </div>
            }

            <!-- ▸ Attempts Before Completion -->
            @case (SectionId.ATTEMPTS_BEFORE_COMPLETION) {
            <div class="card-bg p-5 [@media(max-height:712px)]:p-4 rounded-2xl flex flex-col h-full min-h-[400px]">
                <div class="mb-4">
                    <h2 class="text-lg font-bold text-slate-800 dark:text-white">Attempts Before Completion</h2>
                    <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">Distribution of business required to
                        achieve first successful session</p>
                </div>

                <div class="flex-1 flex flex-row items-center justify-between relative min-h-0 overflow-hidden">
                    @if (attemptsData.length > 0) {
                    <div class="flex-1  min-w-0">
                        <app-polar-area-chart [data]="attemptsData" [valueType]="'number'"
                            class="w-full"></app-polar-area-chart>
                    </div>

                    <!-- Custom Legend for Attempts (Right Side) -->
                    <div class="flex flex-col gap-4 pr-2 sm:pr-4 shrink-0">
                        @for (item of attemptsData; track $index) {
                        <div
                            class="flex items-center gap-3 group/legend cursor-pointer hover:translate-x-1 transition-transform">
                            <div class="w-3 h-3 rounded-full shadow-sm" [style.background-color]="item.color"></div>
                            <div class="flex flex-col">
                                <span
                                    class="text-base font-bold text-slate-700 dark:text-slate-300 group-hover/legend:text-purple-500 transition-colors">{{
                                    item.label }}</span>
                                <span class="text-[10px] text-slate-400 font-medium">{{ item.value.toLocaleString()
                                    }}</span>
                            </div>
                        </div>
                        }
                    </div>
                    } @else {
                    <div class="flex flex-col items-center justify-center w-full h-full py-12 text-gray-500">
                        <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
                        <p class="text-lg font-medium">No data available</p>
                        <p class="text-sm mt-1">Data will appear here when available</p>
                    </div>
                    }
                </div>
            </div>
            }

            <!-- ▸ Unregistered Booking Conversion -->
            @case (SectionId.UNREGISTERED_BOOKING_CONVERSION) {
            <div class="card-bg p-5 [@media(max-height:712px)]:p-4 rounded-2xl flex flex-col h-full min-h-[400px]">
                <div class="mb-4">
                    <h2 class="text-lg font-bold text-slate-800 dark:text-white">Unregistered Booking Conversion
                    </h2>
                    <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">Distribution of bookings converted to
                        registered accounts vs. still unregistered</p>
                </div>

                <div class="flex-1 flex flex-col md:flex-row items-center justify-between relative min-h-0 gap-8 mt-4">
                    @if (conversionData.length > 0) {
                    <!-- Chart Area -->
                    <div class="flex-1 w-full h-full min-w-0 flex flex-col justify-center items-center">
                        <div class="relative w-full max-w-[300px] flex flex-col items-center justify-center">
                            <app-donut-chart [data]="conversionData" [variant]="'concentric'" [semiCircle]="true"
                                [width]="300" [height]="170" [radiusScale]="1.0" [translateX]="0" [translateY]="-20"
                                [roundedCaps]="true" [outerRadiusRatio]="1.0" [innerRadiusRatio]="0.4" [gapRatio]="0.35"
                                class="w-full"></app-donut-chart>
                            <div
                                class="absolute -bottom-1 left-0 right-0 flex justify-between w-full text-[10px] uppercase text-slate-400 dark:text-slate-500 font-bold px-2 tracking-tighter">
                                <span>0%</span>
                                <span>100%</span>
                            </div>
                        </div>
                    </div>

                    <!-- Legend Area (Right) -->
                    <div class="flex flex-col gap-6 shrink-0 md:min-w-[250px] justify-center">
                        @for (item of conversionData; track $index) {
                        <div class="flex items-start gap-3">
                            <div class="w-4 h-4 rounded-full mt-1 shrink-0 shadow-sm"
                                [style.background-color]="item.color">
                            </div>
                            <div class="flex flex-col">
                                <span class="text-base font-bold text-slate-800 dark:text-white leading-tight">{{
                                    item.label }}: {{ item.value }}</span>
                                <span class="text-sm font-medium text-slate-500 dark:text-slate-400 mt-1">({{
                                    (item.value / getTotalConversion() * 100).toFixed(2) }}%)</span>
                            </div>
                        </div>
                        }
                    </div>
                    } @else {
                    <div class="flex flex-col items-center justify-center w-full h-full py-12 text-gray-500">
                        <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
                        <p class="text-lg font-medium">No data available</p>
                        <p class="text-sm mt-1">Data will appear here when available</p>
                    </div>
                    }
                </div>
            </div>
            }


            <!-- ▸ Post-Training Registration Journey & Contract Creation -->
            @case (SectionId.POST_REGISTRATION_JOURNEY) {
            <div
                class="card-bg p-8 [@media(max-height:712px)]:p-5 rounded-2xl flex flex-col h-full min-h-[500px] [@media(max-height:712px)]:min-h-[400px]">
                <div class="mb-4">
                    <h2 class="text-lg font-bold text-slate-800 dark:text-white">Post-Training Registration Journey &
                        Contract Creation</h2>
                    <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">Contract creation comparison:
                        pre-training,
                        post-training, and untrained users.</p>
                </div>

                <div class="flex-1 min-h-0">
                    @if (registrationJourneyMadeData.length > 0) {
                    <app-multiple-bar [data1]="registrationJourneyMadeData" [data2]="registrationJourneyNoData"
                        [legendData]="registrationJourneyLegend" [colors]="registrationJourneyColors"
                        [tooltipData]="registrationJourneyTooltip" [valueKey]="'total'" [valueType]="'number'"
                        [labelKey]="'label'" [showBarValues]="false" [addGradient]="true" [barClusterPixel]="40"
                        [maxBarWidth]="50" [showCard]="false" [showStripes]="true" [showDynamicxAxisLabel]="true"
                        [xAxisFontSize]="'12px'" [legendPosition]="'center'"></app-multiple-bar>
                    } @else {
                    <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
                        <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
                        <p class="text-lg font-medium">No data available</p>
                        <p class="text-sm mt-1">Data will appear here when available</p>
                    </div>
                    }
                </div>
            </div>
            }

            <!-- ▸ Time to First Contract Distribution -->
            @case (SectionId.TIME_TO_FIRST_CONTRACT) {
            <div
                class="card-bg p-8 [@media(max-height:712px)]:p-5 rounded-2xl flex flex-col h-full min-h-[500px] [@media(max-height:712px)]:min-h-[400px]">
                <div class="mb-4">
                    <h2 class="text-lg font-bold text-slate-800 dark:text-white">Time to First Contract Distribution
                    </h2>
                    <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">Time to first contract for trained users,
                        highlighting peak conversion window.</p>
                </div>

                <div class="flex-1 flex flex-row items-center justify-between relative min-h-0 overflow-hidden">
                    @if (timeToFirstContractData.length > 0) {
                    <div class="flex-1  min-w-0">
                        <app-radial-pie-chart [data]="timeToFirstContractData" [levels]="6" class="w-full h-full">
                        </app-radial-pie-chart>
                    </div>

                    <!-- Custom Legend for Time to Contract (Right Side) -->
                    <div class="flex flex-col gap-4 pr-2 sm:pr-8 shrink-0">
                        @for (item of timeToFirstContractData; track $index) {
                        <div
                            class="flex items-start gap-4 group/legend cursor-pointer hover:translate-x-1 transition-transform">
                            <div class="w-1.5 h-10 rounded-full shadow-sm" [style.background-color]="item.color"></div>
                            <div class="flex flex-col">
                                <span
                                    class="text-xs font-bold text-slate-700 dark:text-slate-300 group-hover/legend:text-blue-500 transition-colors">{{
                                    item.label }}: {{ item.value.toLocaleString() }}</span>
                                <span class="text-[10px] text-slate-400 font-bold">{{ item.percentage }}% of
                                    total</span>
                            </div>
                        </div>
                        }
                    </div>
                    } @else {
                    <div class="flex flex-col items-center justify-center w-full h-full py-12 text-gray-500">
                        <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
                        <p class="text-lg font-medium">No data available</p>
                        <p class="text-sm mt-1">Data will appear here when available</p>
                    </div>
                    }
                </div>
            </div>
            }


            <!-- ▸ Top Admins by Sessions Managed -->
            @case (SectionId.TOP_ADMINS) {
            <div
                class="card-bg p-8 [@media(max-height:712px)]:p-5 rounded-2xl flex flex-col h-full min-h-[600px] [@media(max-height:712px)]:min-h-[450px] [@media(max-height:607px)]:min-h-[380px]">
                <div class="mb-4">
                    <h2 class="text-lg font-bold text-slate-800 dark:text-white">Top Admins by Sessions Managed</h2>
                    <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">Total bookings handled and completion
                        effectiveness by admin.</p>
                </div>

                <div class="flex-1 min-h-0 flex flex-col">
                    @if (topAdminsData.length > 0) {
                    <!-- Scrollable Bars Area -->
                    <div class="flex-1 overflow-y-auto scrollbar-theme pr-2">
                        <app-horizontal-bar-chart [data]="topAdminsData" [showLegend]="false" [barHeight]="40"
                            [barPadding]="0.4" [showBarsValue]="false" [showXAxisGrid]="true" [showXAxisLabel]="false"
                            [showYAxisLine]="true" [showYTicks]="true" [marginBottom]="0" [showStripes]="true"
                            [valueType]="'%'" [forceMaxVal]="topAdminsMaxVal"
                            [showTooltipTotal]="false"></app-horizontal-bar-chart>
                    </div>

                    <!-- Fixed Legend Area (No X-Axis) -->
                    <div class="shrink-0">
                        <app-horizontal-bar-chart [data]="[topAdminsData[0]]" [showLegend]="true"
                            [legendItems]="topAdminsLegend" [barHeight]="0" [minHeight]="0" [showBarsValue]="false"
                            [showXAxisGrid]="false" [showXAxisLabel]="false" [showYAxisLine]="false"
                            [showYAxisLabel]="false" [marginTop]="0" [marginBottom]="40" [showStripes]="false"
                            [valueType]="'%'" [forceMaxVal]="topAdminsMaxVal"
                            [showTooltipTotal]="false"></app-horizontal-bar-chart>
                    </div>
                    } @else {
                    <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
                        <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
                        <p class="text-lg font-medium">No data available</p>
                        <p class="text-sm mt-1">Data will appear here when available</p>
                    </div>
                    }
                </div>
            </div>
            }

            <!-- ▸ Full Admin Conversion Table -->
            @case (SectionId.ADMIN_CONVERSION_TABLE) {
            <div
                class="card-bg p-8 [@media(max-height:712px)]:p-5 rounded-2xl flex flex-col h-full min-h-[500px] [@media(max-height:712px)]:min-h-[400px] [@media(max-height:607px)]:min-h-[300px]">
                <div class="flex items-center justify-between mb-8">
                    <div>
                        <h2 class="text-lg font-bold text-slate-800 dark:text-white">Full Admin Conversion Table</h2>
                        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">Complete Overview of All Admin
                            Conversions</p>
                    </div>
                </div>

                <div class="flex-1 overflow-x-auto">
                    @if (adminTableData.length > 0) {
                    <app-paginated-table [headers]="adminTableHeaders" [tableData]="adminTableData" [pageSize]="10"
                        [paddingYAxis]="'py-4'" [headerClass]="'bg-[#F8FAFC] dark:bg-slate-800/40'"
                        [tableWrapperClass]="'border-none'"></app-paginated-table>
                    } @else {
                    <div
                        class="flex flex-col items-center justify-center h-full  text-gray-500 border border-dashed border-slate-200 dark:border-slate-700/50 rounded-xl">
                        <app-icon name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon>
                        <p class="text-lg font-medium">No admin conversion data available</p>
                        <p class="text-sm mt-1">Data will appear here when available</p>
                    </div>
                    }
                </div>
            </div>
            }
            }
        </div>
        }
    </div>
</div>

<!-- ═════════════════════════════════════════════════════════════════════════ -->
<!--  Customize Layout Popup — Mini-Dashboard Editor.
      Inline overlay that visually mirrors the actual training-dashboard
      sections. Tiles support drag-drop reordering, width resizing
      (4 / 6 / 8 / 12 chips), and visibility toggling — applied to the live
      page when the user hits Apply. -->
<!-- ═════════════════════════════════════════════════════════════════════════ -->
@if (isLayoutEditorOpen()) {
<!-- z-[10000] sits above the global navbar/sidebar (which use z-[999]) so the popup never gets clipped by the dashboard header. -->
<div appLayoutEditorOverlay
    class="fixed inset-0 z-[10010] flex items-center justify-center p-3 sm:p-6 bg-slate-900/60 backdrop-blur-sm animate-fadeIn overflow-hidden"
    (click)="closeLayoutEditor()">

    <div class="layout-editor-popup relative w-full max-w-[1100px] max-h-[min(88vh,calc(100vh-2rem))] flex flex-col bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-700 overflow-hidden"
        (click)="$event.stopPropagation()">

        <!--  Header -->
        <div
            class="flex flex-wrap items-center justify-between gap-3 px-5 sm:px-6 py-4 border-b border-slate-200 dark:border-slate-700 bg-gradient-to-r from-[#AD46FF]/5 via-white to-[#AD46FF]/5 dark:from-purple-500/10 dark:via-slate-900 dark:to-purple-500/10">
            <div class="flex items-center gap-3 min-w-0">
                <div
                    class="w-10 h-10 rounded-xl bg-gradient-to-br from-[#AD46FF] to-[#7c3aed] flex items-center justify-center shadow-lg shadow-[#AD46FF]/30 shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                        <rect width="7" height="9" x="3" y="3" rx="1" />
                        <rect width="7" height="5" x="14" y="3" rx="1" />
                        <rect width="7" height="9" x="14" y="12" rx="1" />
                        <rect width="7" height="5" x="3" y="16" rx="1" />
                    </svg>
                </div>
                <div class="min-w-0">
                    <h2 class="text-lg sm:text-xl font-semibold text-[#141437] dark:text-white truncate">
                        Customize Layout
                    </h2>
                    <p class="text-[11px] text-violet-700 dark:text-violet-300">
                        <b>Drag</b> a card to reorder &middot; click the <b>width chips</b> to resize &middot; toggle
                        the <b>eye</b> to hide/show &middot; the preview mirrors the real dashboard.
                    </p>
                </div>
            </div>

            <div class="flex items-center gap-2.5 flex-wrap">
                <!-- Auto Adjust Width: expands the smallest card in each row
                     of the preview so any leftover columns are filled. -->
                <button type="button" (click)="autoAdjustEditorWidths()" [disabled]="!canAutoAdjustEditorWidths()"
                    class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all"
                    [ngClass]="canAutoAdjustEditorWidths()
                        ? 'bg-white dark:bg-slate-800 text-[#AD46FF] border border-[#AD46FF]/30 hover:bg-violet-50 dark:hover:bg-white/5 hover:border-[#AD46FF]/60 shadow-sm cursor-pointer'
                        : 'bg-slate-50 dark:bg-slate-800 text-slate-400 dark:text-slate-500 border border-slate-200 dark:border-slate-700 cursor-not-allowed'"
                    title="Expand the smallest card in each row to fill the leftover columns">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="15 3 21 3 21 9" />
                        <polyline points="9 21 3 21 3 15" />
                        <line x1="21" y1="3" x2="14" y2="10" />
                        <line x1="3" y1="21" x2="10" y2="14" />
                    </svg>
                    Auto Adjust Width
                </button>

                <!-- Visible count chip -->
                <span
                    class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-violet-50 dark:bg-violet-500/10 text-[#AD46FF] border border-[#AD46FF]/20">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                        <circle cx="12" cy="12" r="3" />
                    </svg>
                    {{ editorVisibleCount() }} / {{ editorItems().length }} visible
                </span>

                <!-- Close -->
                <button type="button" (click)="closeLayoutEditor()"
                    class="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                    title="Close">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                    </svg>
                </button>
            </div>
        </div>

        <!-- Layout Preview Area (mini dashboard editor) -->
        <div class="flex-1 overflow-y-auto custom-scroll bg-[#FAFAFE] dark:bg-slate-950/40 p-3 sm:p-4">

            <!-- 12-col mini grid: cdkDropList enables drag-drop reordering;
                 tile widths come from `getEditorColSpanClass(item.colSpan)`. -->
            <div cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="onEditorCardDrop($event)"
                class="grid grid-cols-12 gap-2 sm:gap-2.5 grid-flow-row-dense">

                @for (item of editorItems(); track trackEditorItem($index, item)) {
                <div cdkDrag cdkDragBoundary=".layout-editor-popup" [cdkDragData]="item" [cdkDragDisabled]="!item.visible" [ngClass]="[
                        getEditorColSpanClass(item.colSpan),
                        item.visible
                            ? 'border-slate-200 dark:border-slate-700 shadow-sm hover:shadow-lg hover:-translate-y-0.5 hover:border-[#AD46FF]/40 cursor-grab active:cursor-grabbing'
                            : 'border-dashed border-slate-300 dark:border-slate-600 opacity-60 cursor-not-allowed'
                    ]"
                    class="layout-editor-tile group relative rounded-xl border bg-white dark:bg-slate-800 transition-all duration-200 overflow-hidden">

                    <!-- Drop placeholder (highlight slot during drag) -->
                    <div *cdkDragPlaceholder [ngClass]="getEditorColSpanClass(item.colSpan)"
                        class="rounded-xl border-2 border-dashed border-[#AD46FF]/60 bg-violet-50 dark:bg-violet-500/10 min-h-[88px]">
                    </div>

                    <!-- Tile header: drag handle + title + visibility toggle -->
                    <div class="flex items-start justify-between gap-2 px-2.5 pt-2 pb-1">
                        <div class="flex items-center gap-1.5 min-w-0">
                            <span
                                class="text-slate-300 dark:text-slate-600 group-hover:text-[#AD46FF] transition-colors shrink-0"
                                title="Drag to reorder">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="currentColor" stroke="none">
                                    <circle cx="9" cy="5" r="1" />
                                    <circle cx="9" cy="12" r="1" />
                                    <circle cx="9" cy="19" r="1" />
                                    <circle cx="15" cy="5" r="1" />
                                    <circle cx="15" cy="12" r="1" />
                                    <circle cx="15" cy="19" r="1" />
                                </svg>
                            </span>
                            <span
                                class="text-[11px] sm:text-[12px] font-semibold text-[#141437] dark:text-white truncate"
                                [title]="item.title">
                                {{ item.title }}
                            </span>
                        </div>

                        <!-- Visibility toggle -->
                        <button type="button" (click)="toggleEditorCardVisibility(item.id); $event.stopPropagation()"
                            class="p-1 rounded-md transition-colors shrink-0"
                            [ngClass]="item.visible
                                ? 'text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                                : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700'"
                            [title]="item.visible ? 'Hide section' : 'Show section'">
                            @if (item.visible) {
                            <app-icon-v2 name="eye" [size]="14"></app-icon-v2>
                            } @else {
                            <app-icon-v2 name="eye-off" [size]="14"></app-icon-v2>
                            }
                        </button>
                    </div>

                    <!-- Tile body: scaled-down preview placeholder + width chips. -->
                    <div class="px-2.5 pb-2">
                        <div
                            class="rounded-lg bg-gradient-to-br from-violet-50 via-white to-violet-50/50 dark:from-violet-500/10 dark:via-slate-800 dark:to-violet-500/5 border border-slate-100 dark:border-slate-700/50 h-10 sm:h-10 flex items-center justify-center mb-1.5 overflow-hidden relative">
                            <!-- abstract preview bars -->
                            <div class="flex items-end gap-1 w-2/3 h-1/2 opacity-70">
                                <span class="flex-1 bg-[#AD46FF]/30 rounded-sm" style="height: 40%"></span>
                                <span class="flex-1 bg-[#AD46FF]/50 rounded-sm" style="height: 70%"></span>
                                <span class="flex-1 bg-[#AD46FF]/40 rounded-sm" style="height: 55%"></span>
                                <span class="flex-1 bg-[#AD46FF]/60 rounded-sm" style="height: 90%"></span>
                                <span class="flex-1 bg-[#AD46FF]/35 rounded-sm" style="height: 50%"></span>
                                <span class="flex-1 bg-[#AD46FF]/55 rounded-sm" style="height: 80%"></span>
                            </div>
                            <span
                                class="absolute top-0.5 right-1 text-[9px] font-semibold text-[#AD46FF]/70 uppercase tracking-wider">
                                {{ item.colSpan }}/12
                            </span>
                        </div>
                        <!-- Width selector — minimize-2 / maximize-2 icon buttons step
                             the card through [4 → 6 → 8 → 12] widths.
                             Buttons disable themselves at the boundary. -->
                        <div class="flex items-center gap-1.5">
                            <span
                                class="text-[10px] font-medium text-slate-400 dark:text-slate-500 uppercase tracking-wide mr-0.5">Width</span>

                            <!-- Decrease (minimize-2) -->
                            <button type="button" (click)="decreaseEditorCardColSpan(item.id); $event.stopPropagation()"
                                [disabled]="!canDecreaseEditorCardColSpan(item)"
                                class="p-1 rounded-md border transition-all"
                                [ngClass]="canDecreaseEditorCardColSpan(item)
                                    ? 'bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-[#AD46FF]/50 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                                    : 'bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 border-slate-100 dark:border-slate-700 cursor-not-allowed'"
                                title="Decrease width">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <polyline points="4 14 10 14 10 20" />
                                    <polyline points="20 10 14 10 14 4" />
                                    <line x1="14" y1="10" x2="21" y2="3" />
                                    <line x1="3" y1="21" x2="10" y2="14" />
                                </svg>
                            </button>

                            <!-- Current width pill — Small / Medium / Large / Full -->
                            <span
                                class="inline-flex items-center justify-center min-w-[58px] h-[20px] px-2 rounded-md text-[10px] font-semibold bg-[#AD46FF]/10 text-[#AD46FF] border border-[#AD46FF]/20 select-none whitespace-nowrap">
                                {{ getEditorColSpanLabel(item.colSpan) }}
                            </span>

                            <!-- Increase (maximize-2) -->
                            <button type="button" (click)="increaseEditorCardColSpan(item.id); $event.stopPropagation()"
                                [disabled]="!canIncreaseEditorCardColSpan(item)"
                                class="p-1 rounded-md border transition-all"
                                [ngClass]="canIncreaseEditorCardColSpan(item)
                                    ? 'bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-[#AD46FF]/50 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                                    : 'bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 border-slate-100 dark:border-slate-700 cursor-not-allowed'"
                                title="Increase width">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <polyline points="15 3 21 3 21 9" />
                                    <polyline points="9 21 3 21 3 15" />
                                    <line x1="21" y1="3" x2="14" y2="10" />
                                    <line x1="3" y1="21" x2="10" y2="14" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                }
            </div>

            @if (editorItems().length === 0) {
            <div class="text-center py-16 text-slate-500 dark:text-slate-400">
                <p class="text-sm">No layout items to customize.</p>
            </div>
            }
        </div>

        <!-- ▶ Footer -->
        <div
            class="flex items-center justify-between gap-3 px-5 sm:px-6 py-3.5 border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900">
            <button type="button" (click)="resetLayoutEditorToDefaults()"
                class="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                    <path d="M3 3v5h5" />
                </svg>
                Set Default
            </button>

            <div class="flex items-center gap-2">
                <button type="button" (click)="closeLayoutEditor()"
                    class="px-4 py-2 rounded-lg text-sm font-medium text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors">
                    Cancel
                </button>
                <button type="button" (click)="applyLayoutEditor()" [disabled]="editorVisibleCount() === 0"
                    class="px-5 py-2 rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-[#AD46FF] to-[#7c3aed] hover:shadow-lg hover:shadow-[#AD46FF]/30 hover:-translate-y-px disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0 transition-all">
                    Apply
                </button>
            </div>
        </div>
    </div>
</div>
}